const AIButton = ({ text, Icon = null, onClick, className = "" }) => (
  <button type="default" className={`ai-button ${className || ''}`} onClick={onClick}>
    {Icon && <Icon />}
    <span>{text}</span>
  </button>
);

export default AIButton